var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"image-gallery-list-item"},[_c('v-img',{attrs:{"height":_vm.height,"width":_vm.width,"src":_vm.item.url},on:{"click":function($event){return _vm.handleClickItem(_vm.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }